import React from 'react'
import useStyles from './AppointmentInfoItem.styles'
import { Typography, useTheme } from '@mui/material'

type AppointmentInfoItemProps = {
  label: string
  title?: string
  icon: React.ReactNode
  placeholder?: string
}

const AppointmentInfoItem = ({ label, title, icon, placeholder }: AppointmentInfoItemProps) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className={classes.root}>
      <div>{icon}</div>
      <div>
        <Typography variant="Lato Caption" className={classes.title}>
          {label}
        </Typography>
        {title ? (
          <Typography variant="Lato Emphasized 2">{title}</Typography>
        ) : (
          <Typography variant="Lato Emphasized 2" color={theme.palette.grey[500]}>
            {placeholder}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default AppointmentInfoItem
